import { HeaderContainer, ButtonContainer, Subtitle } from "./UCPListHeader.styled";
import { Typography, Button } from "@ann/web-components";
import { useNavigate } from "react-router-dom";

const UCPListHeader = () => {
  const navigate = useNavigate();

  const handleNewContact = () => {
    navigate("/v1/ucp/new");
  };

  return (
    <HeaderContainer>
      <div>
        <Typography category="title" size="large" weight="bold">
          Contacts
        </Typography>
        <Subtitle>
          <Typography category="body" size="medium" weight="regular">
            Manage all your customer and business contacts in one place. Select a contact to view their profile, interactions, and history.
          </Typography>
        </Subtitle>
      </div>
      {/* <ButtonContainer>
        <Button
          icon=""
          iconLeft=""
          iconRight="plus"
          label="New"
          size="medium"
          type="primary"
          onClick={handleNewContact}
        />
      </ButtonContainer> */}
    </HeaderContainer>
  );
};

export default UCPListHeader; 